<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-checkerboard</v-icon>{{ item['size'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <PrintingSurfaceThicknessForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import PrintingSurfaceThicknessForm from '../../components/printingsurfacethickness/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'PrintingSurfaceThickness';

export default {
  name: 'PrintingSurfaceThicknessUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    PrintingSurfaceThicknessForm
  },

  computed: {
    ...mapFields('printingsurfacethickness', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('printingsurfacethickness', ['find'])

  },

  methods: {
    ...mapActions('printingsurfacethickness', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
